import { NEXT_PUBLIC_IMAGE_URL } from "@/common";

export const heroVersions = [
  {
    versionA: {
      slogan: [
        { text: 'Apply đại vì chưa <br />biết mình hợp gì?' },
        { text: `Chọn ngành học vì <br />"nghe có vẻ ổn"? ` },
        { text: `Sợ chọn nhầm job, <br />nhầm công ty? ` },
        { text: `Không biết làm gì để <br />phát triển?` },
      ],
      centerImageSrc: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/hero-banner.png`,
      showQRCode: true,
    },
    versionB: {
      slogan: [
        { text: 'Người bạn thông minh <br />cho sự nghiệp<br /> Gen Z' },
      ],
      centerImageSrc: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/hero-banner.png`,
      showQRCode: false,
      showDownloadButtons: true,
    },
  },
];
